module.exports = __webpack_public_path__ + "img/ordToning1.21cb3fac.jpg";